__turbopack_context__.v({
  "className": "X9Jc4G_className",
  "variable": "X9Jc4G_variable",
});
